import React from 'react';
import '../styles/disconnected.css';

function DisconnectedScreen({ onReconnect }) {
  return (
    <div className="disconnected-root" role="application" aria-label="Satellite feed terminated">
      {/* Sci-fi background elements */}
      <div className="disconnected-background">
        <div className="static-pattern"></div>
        <div className="warning-indicators">
          <div className="warning-light warning-1"></div>
          <div className="warning-light warning-2"></div>
          <div className="warning-light warning-3"></div>
          <div className="warning-light warning-4"></div>
        </div>
      </div>
      
      {/* Main content */}
      <div className="disconnected-content">
        <div className="status-header">
          <h1>SOLPORT STUDIOS SATELLITE UPLINK SPL-001</h1>
        </div>
        
        <div className="termination-notice">
          <div className="status-icon">⚠</div>
          <h2>FEED TERMINATED</h2>
          <div className="status-details">
            <div>Connection Status: OFFLINE</div>
            <div>Signal Strength: 0%</div>
            <div>Last Contact: {new Date().toLocaleTimeString()}</div>
          </div>
        </div>
        
        <div className="reconnect-section">
          <button
            className="reconnect-button"
            onClick={onReconnect}
            aria-label="Reconnect to satellite"
          >
            <span className="reconnect-main">RECONNECT</span>
            <span className="reconnect-sub">Initialize new uplink session</span>
          </button>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="disconnected-footer">
        <div className="footer-links">
          <a 
            href="https://x.com/solportfun" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="footer-icon">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            <span>@solportfun</span>
          </a>
          
          <div className="footer-separator">|</div>
          
          <a 
            href="/docs" 
            className="footer-link"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="footer-icon">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
            </svg>
            <span>Documentation</span>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default DisconnectedScreen;
